import { useContractFunction } from '@usedapp/core';
import { Contract } from '@ethersproject/contracts';
import { utils } from 'ethers';

export const useMint = (address, abi) => {
  const contract = new Contract(address, abi);
  const { send: payToMint, state: mintState } = useContractFunction(
    contract,
    'mint',
    {
      transactionName: 'Mint NFT',
    }
  );
  const mintWrapper = (_recipient, _tokenUri, _fee) => {
    return payToMint(_recipient, _tokenUri, {
      value: utils.parseEther(_fee),
    });
  };
  return { mintWrapper, mintState };
};
